"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../protons/icons/SystemIcon"));

var _Typography = _interopRequireDefault(require("../../protons/typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    menuItem: {
      height: theme.spacing(6),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.75),
      "&:hover": {
        backgroundColor: theme.palette.grey[200]
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.grey[200]
      }
    },
    listIcon: {
      marginRight: 21
    }
  };
});
/**
 * ** Overflow menus display a list of choices on temporary cards. **
 */

var OverflowMenuItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var action = _ref.action,
      text = _ref.text,
      icon = _ref.icon;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    ref: ref,
    component: "div",
    onClick: function onClick(event) {
      action(event);
    },
    className: styles.menuItem
  }, icon && /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
    className: styles.listIcon
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: icon
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: text
  }));
});

OverflowMenuItem.propTypes = {
  /** Text of the menu item */
  text: _propTypes.default.string.isRequired,

  /** Action to call on the menuitem */
  action: _propTypes.default.func.isRequired,
  ref: _propTypes.default.any,

  /** The left size SystemIcon key */
  icon: _propTypes.default.string
};
OverflowMenuItem.defaultProps = {
  icon: null
};
var _default = OverflowMenuItem;
exports.default = _default;